import TextInfoBloodComp from "../../../../components/Dialog/TextInfoBloodComp";
import { useTranslation } from "../../../../language";

export const TextInfoComp = ({description, lowtext, lowrec, rangetext, hightext, highrec}) => {

   const { t, language } = useTranslation();
   
 return (

  <TextInfoBloodComp

    description = {t(description)}
    lowtext =     {t(lowtext)}
    lowrec =      {t(lowrec)}
    rangetext =   {t(rangetext)}
    hightext =    {t(hightext)}
    highrec =     {t(highrec)}

  />

  )
}

export default TextInfoComp;